import { handleOpenChat } from "utils/analytics";

export default function About() {
  return (
    <div className="flex items-center flex-col flex-wrap p-5">
      <img src="/logo.png" className="h-40" alt="MaragogiAoMar" />
      <h3 className="text-center py-5 text-xl">Tenha uma experiência<br/> inesquecível no Caribe Brasileiro</h3>
      <p className="text-center">
        Nascemos com o proposito de oferecer serviços com excelência para nossos clientes e permanecemos fiéis a esse propósito.<br/>
        Ao longo dos anos temos nos destacado ao oferecermos uma experiência inesquecível com um preço justo.
      </p>
        <button type="button" onClick={handleOpenChat} className="text-white bg-indigo-900 py-2 px-5 rounded mt-5">Fale Conosco</button>
    </div>
  )
}